import { Svg } from 'components/svg'
import { IconType } from 'models'

export const IconOdnoklassniki: IconType = ({ className = '' }) => (
  <Svg className={className} viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M11.93 12.23a3.12 3.12 0 1 0-3.08-3.16 3.09 3.09 0 0 0 3.08 3.16zm0-4.43a1.28 1.28 0 1 1-1.28 1.28 1.31 1.31 0 0 1 1.28-1.28zm3 8.62a.91.91 0 1 1-1.28 1.28l-1.72-1.65-1.73 1.72a.85.85 0 0 1-.6.23.93.93 0 0 1-.67-.3.85.85 0 0 1 0-1.27l1.72-1.73a5.34 5.34 0 0 1-1.8-.7.85.85 0 0 1-.22-1.2 1 1 0 0 1 1.27-.3 3.85 3.85 0 0 0 4.2 0 .9.9 0 0 1 1.28.3.88.88 0 0 1-.3 1.27 5.34 5.34 0 0 1-1.8.75z"
    />
  </Svg>
)
